import React from 'react';
import {
    Box,
    Typography,
    Container,
    Divider,
    Paper,
    createTheme,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import MainRouteFooter from './routes/MainRouteFooter'

function TermofService({ screenWidth, defaultTheme }) {
    const { t } = useTranslation();
    const sections = Array.from({ length: 9 }, (_, i) => i + 1);
    return (
        <>
            <Box sx={{ bgcolor: '#f5fdf7', py: { xs: 4, md: 6 } }}>
                <Container sx={{ maxWidth: '800px' }}>
                    {/* <Paper elevation={3} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3 }}> */}
                    <Typography
                        variant="h4"
                        component="h1"
                        align="center"
                        gutterBottom
                        sx={{ fontWeight: 700, color: 'success.main' }}
                    >
                        {t('terms.title')}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        align="center"
                        color="text.secondary"
                        gutterBottom
                    >
                        {t('terms.updated')}
                    </Typography>
                    <Divider sx={{ my: 3 }} />

                    <Box>
                        <Typography variant="body1" paragraph>
                            <Trans i18nKey="terms.intro" components={{ strong: <strong /> }} />
                        </Typography>

                        {sections.map((n) => (
                            <React.Fragment key={n}>
                                <Typography variant="subtitle1" fontWeight="bold">{t(`terms.section${n}_title`)}</Typography>
                                <Typography variant="body1" paragraph>
                                    <Trans i18nKey={`terms.section${n}_body`} components={{ li: <li />, br: <br />, strong: <strong /> }} />
                                </Typography>
                            </React.Fragment>
                        ))}
                    </Box>
                </Container>
            </Box>
            <Divider sx={{ my: 0 }} />
            <Box sx={{ bgcolor: '#f5fdf7', }}>
                <MainRouteFooter />
            </Box>

        </>
    )
}

export default TermofService